import { ReactNode } from 'react';

import { NsSelectOptionsProps, NsSelectOptions } from './NsSelectOptions';
import { NsInputter } from 'components/common/ns-inputter/NsInputter';
import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import NsInputterEvent from '../ns-inputter/NsInputterEvent';

type NsSelectProps = {
  id?: string;
  label: string;
  placeholder?: string;
  name: string;
  value?: string | number;
  onChange?: (event: NsInputterEvent) => void;
  inputAttributes?: Record<string, string | boolean>;
  options?: NsSelectOptionsProps['options'];
  validation?: string[];
  helper?: string;
  tipDetail?: ReactNode;
  testId?: string;
};

export const NsSelect = ({
  label,
  placeholder = 'Select option',
  name,
  value,
  options,
  validation = [NsInputterValidations.isRequired],
  onChange,
  inputAttributes = {},
  helper,
  tipDetail,
  testId
}: NsSelectProps) => {
  return (
    <NsInputter
      onChange={onChange}
      name={name}
      value={value}
      validation={validation}
      helper={helper}
      tipDetail={tipDetail}
    >
      <label slot="label">{label}</label>
      <select data-testid={testId} {...inputAttributes}>
        <NsSelectOptions options={options} placeholder={placeholder} />
      </select>
    </NsInputter>
  );
};
